export default "__VITE_ASSET__59187a06__"